import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import BaseCardAction from '@/views/base/BaseCardAction.vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import { defineMessages } from '@/lib/i18n';
import { DynamicList } from '@/interfaces/model/general/dynamicList';
import { i18n } from '@/plugins/vue-i18n';
import { store } from '@/store/index';
import { readIsFeatureEnabled } from '@/store/main/getters';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteDynamicListDialog',
  props: {
    value: { type: Boolean },
    selectedDynamicLists: null
  },
  emits: ["input", "delete"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'delete'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  selectedDynamicLists: DynamicList[];
};

const $t = i18n.t.bind(i18n);

const isNewChecklistUIEnabled =
  readIsFeatureEnabled(store)('use_new_regulatory_screening_ui') ?? false;

const m = defineMessages({
  deleteConfirmation: '選択した{count}件のチェックリスト削除しますか?',
  executionWarning:
    '「実行する」をクリックすると、選択されたチェックリストが削除されます。操作は取り消すことはできません。',
  executionWarningTemplateOnly:
    '「実行する」をクリックすると、選択されたチェックリストが削除されます。再度使用する場合は、リスト追加からもう一度追加いただく必要があります。',
});




const model = computed({
  get: () => props.value,
  set: (value) => emit('input', value),
});

// Check if all selected dynamic lists are created from templates
const isAllFromTemplate = computed(() => {
  return (
    props.selectedDynamicLists.length > 0 &&
    props.selectedDynamicLists.every(
      (list) => list.dynamic_list_template_id != null
    )
  );
});

const warningMessage = computed(() => {
  return isNewChecklistUIEnabled && isAllFromTemplate.value
    ? $t(m.executionWarningTemplateOnly)
    : $t(m.executionWarning);
});

const headerMessage = computed(() => {
  return $t(m.deleteConfirmation, { count: props.selectedDynamicLists.length });
});

const closeDialog = () => {
  model.value = false;
};

const handleDeleteClick = () => {
  emit('delete');
  closeDialog();
};

const handleCancelClick = () => {
  closeDialog();
};

return { __sfc: true,$t, isNewChecklistUIEnabled, m, props, emit, model, isAllFromTemplate, warningMessage, headerMessage, closeDialog, handleDeleteClick, handleCancelClick, BaseCardAction, BaseFormCard }
}

})